import IBaseStepModel from "./interfaces/BaseStepModel.interface";

export interface ICheckBalanceStep extends IBaseStepModel  {
    giftCardCode: string;
    remainingBalance: number;
    redeemCode: string;
    currencySymbol: string;
}

export class CheckBalanceStepModel implements ICheckBalanceStep, IBaseStepModel {
    giftCardCode: string;
    remainingBalance: number;
    currencySymbol: string;
    redeemCode: string;
    isDirty: boolean;

    constructor(
    ) {
        this.giftCardCode = "";
        this.remainingBalance = 0;
        this.currencySymbol = "";
        this.redeemCode = "";
    }

    static validateModel(model: ICheckBalanceStep): boolean {

        if (!model) return false;

        if (!model.giftCardCode.trim() || model.giftCardCode.length < 5) return false;

        return true;
    }
}